// extracted by mini-css-extract-plugin
export default {"description":"style_description__esDIW","fade-in":"style_fade-in__RnCwr","top":"style_top__nwHvY","image":"style_image__9orH2"};